var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { putResolve, takeEvery } from 'redux-saga/effects';
import { uploadImagesApi } from 'conversional-api';
import { captureException } from 'conversional-exceptions';
// import * as Actions from '../actions'
import * as sagaUtils from '../../../helper/sagaUtils';
import { sendImages as sendImagesAction, sendImagesFailed, sendImagesSucceeded } from '../appointmentBookingSlice';
import get from "lodash/get";
function sendImages(action) {
    var payload, formData, response, error_1, defaultErrorMsg;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                payload = action.payload;
                formData = new FormData();
                formData.set("file", payload.image.file);
                formData.set("result_alias", payload.resultId);
                _a.label = 1;
            case 1:
                _a.trys.push([1, 6, , 8]);
                return [4 /*yield*/, sagaUtils.api(uploadImagesApi(formData))];
            case 2:
                response = _a.sent();
                if (!response) return [3 /*break*/, 4];
                return [4 /*yield*/, putResolve(sendImagesSucceeded({
                        response: response,
                        image: payload.image
                    }))];
            case 3:
                _a.sent();
                return [3 /*break*/, 5];
            case 4: throw new Error('Send images response is empty');
            case 5: return [3 /*break*/, 8];
            case 6:
                error_1 = _a.sent();
                captureException(error_1, { saga: 'sendImages', action: action });
                defaultErrorMsg = 'Something went wrong. Please try again later.';
                return [4 /*yield*/, putResolve(sendImagesFailed({
                        error: get(error_1, 'response.data'),
                        image: payload.image
                    }))];
            case 7:
                _a.sent();
                return [3 /*break*/, 8];
            case 8: return [2 /*return*/];
        }
    });
}
export default function actionWatcher() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, takeEvery(sendImagesAction.type, sendImages)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
